'use strict';

import angular from 'angular';

/**
 * @typedef {Object} groupTransaction
 * @property {string} name
 * @property {boolean} isActive
 */

export default class GrpTransactionFormCtrl {
  /** @type {groupTransaction} */
  model = {
    name: ''
  };
  /**
   * TODO:
   *  - add auth check
   *  - remove hard coding of toGroup as Altrusa (id: 1)
   */

  constructor($state, $stateParams, LoaderSvc, GrpTxnSvc, GroupAuthSvc,
    GroupSvc) {
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId;
    var groupId = $stateParams.groupId;
    this.groupId = groupId;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.GrpTxnSvc = GrpTxnSvc;
    this.GroupAuthSvc = GroupAuthSvc;
    this.LoaderSvc = LoaderSvc;
    this.model = {amountType: 'debit', amount: 0.00,
      fromGroupId: Number(this.groupId)};

    var that = this;

    this.amountTypes = [{label: 'Debit/Owed', value: 'debit'},
      {label: 'Credit/Paid', value: 'credit'}];

    this.isCreate = $state.current.name.indexOf('new') !== -1;
    // create
    if(this.isCreate) {
      // authorization
      this.GroupAuthSvc.validatePermission(groupId, 'groupTransaction', 'C');

      this.submit = this.createGroupTransaction;
      that.headerText = 'New Group Transaction';
      that.submitText = 'Create Group Transaction';
      GroupSvc.getTimePeriods({groupId: ctxId}).$promise.then(function(tp) {
        that.timePeriods = tp;
      });

      // get valid toGroups in ancestors
      // NOTE: currently allows any parent group that has EVER had a fee defined
      // TODO: reconcile years of fees (included in response
      // w/ time period selectioned
      this.GrpTxnSvc.queryValidToGroups({groupId}).$promise
        .then(function(toGroups) {
          that.toGroups = toGroups;
          var toGroupCount = toGroups ? toGroups.length : 0;
          if(toGroupCount) {
            that.model.toGroupId = toGroups[0].id;
          }
        });
      this.cancelSref = 'group.view.groupTransaction.list';

    // edit
    } else {
      // authorization
      this.GroupAuthSvc.validatePermission(groupId, 'groupTransaction', 'U');

      this.submit = this.updateGroupTransaction;
      var gtId = $stateParams.gtId;
      that.gtId = gtId;
      that.headerText = 'Edit Group Transaction';
      that.submitText = 'Update Group Transaction';
      this.GrpTxnSvc.get({groupId, id: gtId}).$promise
        .then(function(gt) {
          gt = gt.toJSON();
          gt.amountType = gt.amount <= 0 ? 'debit' : 'credit';
          gt.amount = Math.abs(gt.amount) / 100; // cents

          that.timePeriods = [gt.timePeriod];
          that.toGroups = [gt.toGroup];
          that.model = angular.extend({}, that.model, angular.copy(gt));
          that.display = gt;
        });
      this.cancelSref = 'group.view.groupTransaction.list';
    }
  }

  prepGrpTxn(grpTxn) {
    var that = this;
    grpTxn.toGroupId = grpTxn.toGroupId || that.ctxId;
    grpTxn.amount = grpTxn.amount * 100; // cents
    if(grpTxn.amountType === 'debit') { grpTxn.amount = grpTxn.amount * -1; }
    delete grpTxn.amountType;
    return grpTxn;
  }

  createGroupTransaction() {
    var that = this;
    that.LoaderSvc.start();
    var grpTxn = that.prepGrpTxn(angular.copy(that.model));

    var reqParams = { groupId: that.groupId };
    that.GrpTxnSvc.create(reqParams, grpTxn).$promise
      .then(function(gt) {
        that.LoaderSvc.stopSuccess('Group Transaction Created');
        that.$state.go('group.view.groupTransaction.view',
          {gtId: gt.id});
      }).catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }

  updateGroupTransaction() {
    var that = this;
    that.LoaderSvc.start();
    var grpTxn = that.prepGrpTxn(angular.copy(that.model));
    var reqParams = {
      groupId: that.groupId,
      id: that.gtId
    };
    this.GrpTxnSvc.update(reqParams, grpTxn).$promise.then(function() {
      that.$state
        .go('group.view.groupTransaction.view', {gtId: that.gtId});
      that.LoaderSvc.stopSuccess('Group Transaction Updated');
    })
      .catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }
}
